import Svani1 from '../../../Media/BSD/Tanakayu/Tanakayu Svani.webp'
import Svani2 from '../../../Media/BSD/Tanakayu/Tanakayu Svani.webp'





const Svaniimages =[
Svani1,Svani2
]

export default Svaniimages;